const translations = {
  ru: {
    header: {
      title: "Diamond VPN",
      subtitle: "Стань тенью в цифровом потоке. Полная анонимность. Мгновенно. Надёжно."
    },
    main:{
      cta_start: 'Начать использование',
      advantages: {
        title: 'Наши преимущества',
        speed: {
          title: 'Высокая скорость',
          desc: 'Оптимизированные сервера обеспечивают стабильное и быстрое соединение.'
        },
        privacy: {
          title: 'Конфиденциальность',
          desc: 'Мы не отслеживаем активность пользователей и не продаём ваши данные.'
        },
        simplicity: {
          title: 'Простота использования',
          desc: 'Подключение в пару кликов — без сложных настроек.'
        },
        stability: {
          title: 'Стабильность',
          desc: 'Надёжная инфраструктура и стабильные соединения 24/7.'
        }
      },
      faq: {
        title: 'FAQ',
        q1_title: 'Что такое DiamondVPN и чем он отличается от других VPN?',
        q1_text: 'DiamondVPN — это сервис, который шифрует трафик и использует современные протоколы для стабильного и безопасного доступа к интернету.',
        q2_title: 'Есть ли пробный период и как им воспользоваться?',
        q2_text: 'Если для вашего региона доступен пробный период, его можно активировать в профиле в один клик.',
        q3_title: 'Какие способы оплаты доступны?',
        q3_text: 'Способы оплаты зависят от региона: банковские карты (YooKassa/Tribute) и криптовалюта (Heleket).',
        q4_title: 'Как связаться с поддержкой?',
        q4_text: 'Через встроенный чат поддержки на сайте (кнопка справа внизу) или в Telegram: @diamondvpnsupport.',
        q5_title: 'Есть ли ограничения по устройствам?',
        q5_text: 'Обычно можно подключать несколько устройств. При необходимости ограничения могут применяться для защиты от шаринга.',
        q6_title: 'Есть ли лимит трафика?',
        q6_text: 'В тарифах может быть лимит трафика и стратегия его сброса (день/неделя/месяц/без сброса). Актуальные значения и расход видны в профиле.',
        q7_title: 'Как увеличить трафик или сбросить расход?',
        q7_text: 'В блоке «Соберите свой тариф» можно докупить дополнительные ГБ: доплата = доп. ГБ × цена за ГБ/мес × количество месяцев. Также доступен платный «Сбросить трафик»: стоимость рассчитывается как лимит трафика × цена за ГБ/мес.'
      },
    },
    trial: {
      banner: "15 дней БЕСПЛАТНО для новых пользователей!"
    },
    referral: {
      banner: "Получи 7 дней за каждого реферала!"
    },
    pricing: {
      title: "Выберите тарифный план",
      loading: "Загрузка тарифов...",
      bestOffer: "Лучшее предложение",
      savings: "Экономия {{savings}}₽",
      builder: {
        title: "Соберите свой тариф",
        months: "Месяцы:",
        traffic: "ГБ трафика:",
        base: "База",
        pricePerGb: "Цена за ГБ/мес",
        term: "Срок",
        monthsValue: "{{months}} мес",
        extraGb: "Доп. ГБ:",
        enter: "Введите",
        extraCost: "Доплата:",
        pay: "Оплатить",
        payAmount: "Оплатить {{amount}} {{currency}}",
        ownGb: "Своё количество ГБ:",
        ownGbPlaceholder: "Введите (не менее {min}):",
        tributeExtraUnavailable: "Оплата через Tribute для доп. трафика пока недоступна.",
        errorYooKassa: "Не удалось подготовить платёж через YooKassa",
        errorPlatega: "Не удалось подготовить платёж через Platega",
        errorTribute: "Не удалось подготовить платёж через Tribute",
        errorCrypto: "Не удалось подготовить крипто-платёж"
      }
    },
    buttons: {
      buy: "Купить {{plan}} - {{price}} {{currency}}💎",
      select_plan: "Выберите тарифный план",
      manual: "Инструкция",
      profile: "Мой профиль",
      news: "Новости"
    },
    profile: {
      title: "Профиль",
      subscription: "Статус подписки",
      active: "✅ Активна до {{date}}",
      inactive: "❌ Подписка не активна",
      traffic_used: "Использовано трафика: {{used}} GB / {{total}} GB",
      trial: {
        banner: "🎁 Получите 15 дней бесплатного пробного периода!",
        activate: "Активировать пробный период"
      },
      connect : "Подключиться",
      payments: "История платежей",
      no_payments: "Платежей пока нет",
      login: {
        title: "Войдите в аккаунт",
        description: "Для доступа к профилю и управления подпиской требуется авторизация",
        google: "Войти через Google"
      },
      logout: "Выйти",
      select_plan: "Выберите тарифный план",
      email: "Email",
      trial_used: "Пробный период использован",
      show_more: "Показать еще",
      show_less: "Скрыть",
      payment_status: {
        succeeded: "✅ Оплачено",
        pending: "⏳ Ожидание",
        canceled: "❌ Отменено"
      },
      subscription_link : "Ссылка: {{link}}",
      referral: {
        title: "Реферальная программа",
        description: "Приглашайте друзей и получайте +7 дней подписки за каждого друга, активировавшего пробный период!",
        total_referrals: "Всего приглашено",
        active_referrals: "Активировали пробный период",
        copy: "Копировать",
        copied: "Скопировано!"
      },
      traffic_weekly: "Ежемесячный лимит",
      traffic_spent: "Потрачено: {{used}} GB из {{total}} GB",
      traffic_reset_note: "Лимит сбрасывается 1-го числа каждого месяца",
      traffic_renew_note: "При продлении подписки использованный трафик не сбрасывается",
      show_qr: "Показать QR",
      connection_online: "VPN онлайн",
      connection_last_seen: "Был онлайн: {{time}}",
      connection_unknown: "Статус подключения: нет данных",
      traffic_chart_title: "Расход трафика",
      traffic_chart_empty: "Данных по трафику пока нет",
      traffic_chart_total: "Всего за период",
      traffic_chart_top_nodes: "Основные локации",
      traffic_range_day: "День",
      traffic_range_week: "Неделя",
      traffic_range_month: "Месяц"
    },
    paymentModal: {
      title: "Выберите способ оплаты",
      method: {
        yookassa: "YooKassa (карта/СБП)",
        platega: "Platega (карта/СБП)",
        tribute: "Tribute (бот)",
        crypto: "Криптовалюта (Heleket)",
      },
      action: {
        pay: "Оплатить",
        loading: "Загрузка...",
        cancel: "Отмена",
      },
      hints: {
        yookassa: "YooKassa — для карт РФ и СБП.",
        platega: "Platega - оплата картой или СБП.",
        tribute: "Tribute — оплата картами со всего мира через Telegram-бота.",
        crypto: "Криптовалюта — оплата через Heleket.",
      },
      error: {
        generic: "Что-то пошло не так..."
      },
      noMethods: "Нет доступных способов оплаты"
    },

    manual: {
      title: "Инструкция",
      subtitle: "Настройка VPN на устройствах",
      sidebar: {
        title: 'Инструкции',
        subtitle: 'Настройка VPN на устройствах'
      },
      contentTitle: '{{app}} для {{device}}',
      selectDevice: 'Выберите устройство',
      stepByStep: 'Пошаговая инструкция по настройке VPN',
      selectPrompt: 'Выберите устройство и приложение в меню, чтобы посмотреть подробные инструкции по настройке VPN.'
    },
    footer: {
      copyright: "© 2026 Diamond VPN. Все права защищены.",
      support: "Техподдержка:",
      owner: "Владелец Сервиса: Diamond Services."
    },
    common: {
      loading: "Загрузка...",
      back: "Назад"
    },
    supportChat: {
      open: "Открыть чат поддержки",
      close: "Закрыть",
      title: "Чат с поддержкой",
      placeholder: "Напишите сообщение...",
      send: "Отправить",
      sending: "Отправка...",
      empty: "Пока сообщений нет. Напишите нам — мы ответим.",
      too_long: "Длина сообщения превышает лимит (максимум 4000 символов).",
      fab: "Чат"
    },
    
    news: {
      title: "Новости",
      subtitle: "Свежие обновления и новости сервиса.",
      empty: "Пока нет новостей.",
      end: "Это все новости."
    },
    download: {
      title: "Скачать приложения",
      subtitle: "Выберите платформу и установите приложение.",
      android: { title: "Android", desc: "Скоро в Google play, а пока что так", button: "Скачать" },
      ios: { 
        title: "iOS", 
        desc: "Скачайте Happ из App Store для работы с VPN.", 
        note: "Используйте приложение Happ для подключения к VPN. Инструкция — на видео ниже.",
        buttonRu: "Ru",
        buttonGlobal: "Global"
      },
      windows: { title: "Windows", desc: "", button: "Скачать" },
      howTo: {
        title: "Как пользоваться?",
        platformLabel: "Выберите вашу платформу:",
        windows: "Windows",
        android: "Android",
        ios: "iOS",
        otherInstructions: "Инструкции для других приложений"
      }
    },
    terms: {
      title: "Пользовательское соглашение (Публичная оферта)",
      lastUpdated: "Дата последнего изменения: 21 октября 2026 г.",
      sections: {
        general: "1. Общие положения",
        subject: "2. Предмет Соглашения",
        ownerRights: "3. Права и обязанности Владельца",
        userRights: "4. Права и обязанности Пользователя",
        responsibility: "5. Ответственность сторон и разрешение споров",
        ethics: "6. Этические принципы использования",
        final: "7. Заключительные положения"
      },
      content: {
        general: {
          items: [
            "Настоящее Пользовательское соглашение (далее — Соглашение) является публичной офертой в соответствии со статьей 437 Гражданского кодекса Российской Федерации.",
            "Использование Сервиса Пользователем (в том числе просмотр размещенных на Сайте материалов, регистрация, приобретение подписки) означает полное и безоговорочное принятие Пользователем условий настоящего Соглашения и Политики конфиденциальности.",
            "Владельцем Сервиса Diamond VPN (далее — Владелец) является Diamond Services.",
            "Условия настоящего Соглашения могут быть изменены Владельцем в одностороннем порядке без предварительного уведомления."
          ]
        },
        subject: {
          items: [
            "Владелец предоставляет Пользователю неисключительное право использовать Сервис VPN-подключения (далее — Услуга) в соответствии с условиями настоящего Соглашения.",
            "Услуга предназначена исключительно для обеспечения безопасности, конфиденциальности и защиты данных Пользователя при использовании сети Интернет."
          ]
        },
        ownerRights: {
          items: [
            "Владелец обязуется обеспечить техническую возможность доступа к Сервису на оплаченный период.",
            "Владелец обязуется не хранить и не передавать третьим лицам журналы активности Пользователя (No-Logs Policy) в соответствии с Политикой конфиденциальности.",
            "Владелец вправе приостановить или прекратить предоставление Услуги в случае нарушения Пользователем данного Соглашения.",
            "Владелец имеет право вносить изменения в тарифные планы, программное обеспечение и технические характеристики Сервиса с предварительным уведомлением или без него.",
            "Владелец обязан обеспечить соблюдение требований Федерального закона от 27.07.2006 N 152-ФЗ «О персональных данных» в части обработки личных данных, предоставленных Пользователем (email для связи, данные для оплаты), как указано в Политике конфиденциальности."
          ]
        },
        userRights: {
          items: [
            "Пользователь обязуется использовать Сервис только в законных целях и в соответствии с законодательством Российской Федерации и страны своего пребывания.",
            "Пользователь несет полную личную ответственность за любую деятельность, осуществляемую им во время использования Сервиса, включая содержание передаваемой информации.",
            "Пользователю запрещается использовать Сервис для:",
            "Пользователь обязуется не передавать свои учетные данные третьим лицам и несет ответственность за их сохранность."
          ],
          prohibitedItems: [
              "Совершения любых противоправных действий, включая, но не ограничиваясь: мошенничество, распространение вредоносного ПО, несанкционированный доступ к компьютерным системам.",
              "Распространения контента, запрещенного или ограниченного законодательством Российской Федерации (детская порнография, экстремистские материалы, пропаганда наркотиков и т.д.).",
              "Нарушения авторских и смежных прав третьих лиц.",
              "Нарушения надлежащего функционирования Сайта и Сервиса."
            ],
        },
        responsibility: {
          items: [
            "Владелец не несет ответственности за любые прямые или косвенные убытки Пользователя, возникшие в результате использования или невозможности использования Сервиса, за исключением случаев, предусмотренных законом.",
            "Владелец не несет ответственности за любой незаконный контент или действия, совершаемые Пользователем при использовании Сервиса. Пользователь самостоятельно несет ответственность за соблюдение законодательства.",
            "Все споры и разногласия, возникающие между Сторонами в связи с исполнением настоящего Соглашения, разрешаются путем переговоров.",
            "В случае недостижения согласия, споры разрешаются в судебном порядке в соответствии с законодательством Российской Федерации по месту нахождения Владельца Сервиса."
          ]
        },
        ethics: {
          items: [
            "В целях формирования ответственного интернет-сообщества, Владелец Сервиса придерживается принципов честности, уважения и добропорядочности. Пользователям рекомендуется использовать Сервис только для дозволенных (законных и моральных) целей, избегая действий, противоречащих нормам морали и этике."
          ]
        },
        final: {
          items: [
            "Настоящее Соглашение вступает в силу с момента выражения Пользователем согласия с его условиями (акцепта) и действует до момента расторжения.",
            "Принятие Соглашения допускается только в полном объеме.",
            "Вопросы, не урегулированные настоящим Соглашением, подлежат разрешению в соответствии с законодательством Российской Федерации."
          ]
        }
      }
    },
    refund: {
      title: "Политика возврата средств Diamond VPN",
      sections: {
        guarantee: "1. Условия гарантии возврата",
        procedure: "2. Порядок запроса возврата",
        timing: "3. Сроки обработки возврата",
        contacts: "4. Контакты"
      },
      content: {
        intro: "Мы стремимся к полному удовлетворению потребностей наших пользователей. Если вы не удовлетворены сервисом, вы можете запросить возврат средств согласно следующим условиям.",
        guarantee: {
          description: "Сервис Diamond VPN предоставляет <b>14-дневную гарантию возврата средств</b> с момента покупки любого платного тарифного плана. Возврат средств возможен при соблюдении следующих условий:",
          items: [
            "Запрос на возврат средств должен быть подан не позднее, чем через <b>14 календарных дней</b> после совершения платежа.",
            "Возврат не может быть осуществлен, если аккаунт был заблокирован из-за нарушения «Правил пользования» (например, противоправная деятельность).",
            "Если вы использовали сервис для превышения объема трафика в <b>50 ГБ</b>, мы оставляем за собой право отказать в полном возврате средств (за исключением случаев, когда проблема на нашей стороне)."
          ]
        },
        procedure: {
          items: [
            "Для запроса возврата отправьте письмо на нашу электронную почту <b>adverthueta@gmail.com</b>.",
            "В письме укажите:",
            "Мы рассмотрим ваш запрос в течение <b>3 рабочих дней</b>."
          ],
          procedureSubItems: [
              "Дату и время покупки.",
              "ID транзакции или номер платежа.",
              "Причину, по которой вы запрашиваете возврат."
            ],
        },
        timing: {
          description: "В случае одобрения возврата:",
          items: [
            "Возврат средств будет осуществлен на тот же платежный метод, который был использован при покупке.",
            "Срок зачисления средств может составлять <b>от 5 до 10 рабочих дней</b> и зависит от вашего банка или платежной системы."
          ]
        },
        contacts: {
          description: "По всем вопросам, связанным с оплатой и возвратом, обращайтесь:",
          email: "Email: <b>adverthueta@gmail.com</b>"
        }
      }
    },
    privacy: {
      title: "Политика конфиденциальности Diamond VPN",
      effectiveDate: "Дата вступления в силу: 21 октября 2026 г.",
      sections: {
        noLogs: "1. Политика «Без журналов» (No-Logs Policy)",
        technicalInfo: "2. Сбор технической информации",
        paymentInfo: "3. Информация, необходимая для оплаты",
        dataProtection: "4. Защита данных",
        thirdParty: "5. Ссылки на сторонние ресурсы"
      },
      content: {
        noLogs: {
          description: "Diamond VPN строго придерживается политики нехранения журналов активности. Это означает, что мы <b>не собираем и не храним</b> следующую информацию, связанную с вашей активностью в интернете:",
          items: [
            "IP-адреса, используемые вами для подключения к Сервису.",
            "История просмотров или поисковых запросов.",
            "Продолжительность сессии, время подключения.",
            "Используемый трафик, файлы, которые вы скачиваете."
          ],
          conclusion: "Ваша онлайн-активность остается полностью приватной и не отслеживается Сервисом."
        },
        technicalInfo: {
          description: "Для обеспечения работы и предоставления услуг мы собираем минимальный объем технической информации:",
          items: [
            "<b>Email-адрес:</b> Используется исключительно для коммуникации, отправки уведомлений об оплате и восстановления доступа к аккаунту.",
            "<b>Технические данные подключения:</b> Данные о потреблении трафика (для контроля подписки), тип устройства (для оптимизации), а также общая информация о сервере, но без привязки к конкретной активности пользователя. Эти данные хранятся анонимно."
          ]
        },
        paymentInfo: {
          description: "Для осуществления платежей мы используем сторонние платежные системы (через Telegram-бот).",
          conclusion: "Мы <b>не получаем и не храним</b> информацию о ваших банковских картах, счетах или других финансовых данных. Вся финансовая информация обрабатывается непосредственно платежными системами, которые несут ответственность за ее безопасность."
        },
        dataProtection: "Мы принимаем все разумные меры для защиты информации, которую мы собираем. Ваш аккаунт защищен паролем. Мы используем шифрование для передачи данных, связанных с управлением аккаунтом.",
        thirdParty: "Наш сайт может содержать ссылки на сторонние ресурсы (например, на Telegram-бот). Мы не несем ответственности за политику конфиденциальности или содержание этих сторонних сайтов."
      }
    }
  },
  en: {
    header: {
      title: "Diamond VPN",
      subtitle: "Become a shadow in the digital stream. Complete anonymity. Instantly. Reliable."
    },
    main: {
      cta_start: 'Get Started',
      advantages: {
        title: 'Our Advantages',
        speed: {
          title: 'High Speed',
          desc: 'Optimized servers provide stable and fast connections.'
        },
        privacy: {
          title: 'Privacy',
          desc: 'We do not track user activity and do not sell your data.'
        },
        simplicity: {
          title: 'Simplicity',
          desc: 'Connect in a couple of clicks — no complex setup.'
        },
        stability: {
          title: 'Stability',
          desc: 'Reliable infrastructure and stable connections 24/7.'
        }
      },
      faq: {
        title: 'FAQ',
        q1_title: 'What is DiamondVPN and how is it different from other VPNs?',
        q1_text: 'DiamondVPN is a service that encrypts traffic and uses modern protocols to maximize anonymity on the network.',
        q2_title: 'Is there a free trial and how do I use it?',
        q2_text: 'If a trial is available for your region, you can activate it in your profile in one click.',
        q3_title: 'What payment methods are available?',
        q3_text: 'Payment methods depend on your region: bank cards (YooKassa/Tribute) and cryptocurrency (Heleket).',
        q4_title: 'How can I contact support if something does not work?',
        q4_text: 'Via the built‑in support chat on the website — the button is in the bottom right corner. You can also write to the Telegram account @diamondvpnsupport or to the email shown at the bottom of the page.',
        q5_title: 'Are there any device limits?',
        q5_text: 'Usually you can connect multiple devices. Limits may be applied if needed to prevent account sharing.',
        q6_title: 'Is there a traffic limit?',
        q6_text: 'Plans may include a traffic limit and a reset strategy (day/week/month/no reset). Your current usage and limits are shown in your profile.',
        q7_title: 'How can I get more traffic or reset usage?',
        q7_text: 'You can buy extra GB in the “Build your plan” block: extra cost = extra GB × price per GB per month × number of months. A paid “Reset traffic” option is also available: price is calculated as traffic limit × price per GB per month.'
      }
    },
    trial: {
      banner: "15 days FREE for new users!"
    },
    referral: {
      banner: "Get 7 days for each referral!"
    },
    pricing: {
      title: "Choose a pricing plan",
      loading: "Loading plans...",
      bestOffer: "Best offer",
      savings: "Save {{savings}}₽",
      builder: {
        title: "Build your plan",
        months: "Months:",
        traffic: "Traffic (GB):",
        base: "Base",
        pricePerGb: "Price/GB/mo",
        term: "Term",
        monthsValue: "{{months}} mo",
        extraGb: "Extra GB:",
        enter: "Enter",
        extraCost: "Extra cost:",
        pay: "Pay",
        payAmount: "Pay {{amount}} {{currency}}",
        ownGb: "Custom GB:",
        ownGbPlaceholder: "Enter (min {min}):",
        tributeExtraUnavailable: "Tribute is not available for extra traffic yet.",
        errorYooKassa: "Failed to prepare YooKassa payment",
        errorPlatega: "Failed to prepare Platega payment",
        errorTribute: "Failed to prepare Tribute payment",
        errorCrypto: "Failed to prepare crypto payment"
      }
    },
    buttons: {
      buy: "Buy {{plan}} - {{price}} {{currency}}💎",
      select_plan: "Select a plan",
      manual: "Manual",
      profile: "My profile",
      news: "News",
      terms: "Terms of use"
    },
  
    profile: {
      title: "Profile",
      subscription: "Subscription status",
      active: "✅ Active until {{date}}",
      inactive: "❌ Subscription inactive",
      traffic_used: "Traffic used: {{used}} GB / {{total}} GB",
      traffic_weekly: "Monthly limit",
      traffic_spent: "Used: {{used}} GB of {{total}} GB",
      traffic_reset_note: "Limit resets on the 1st day of every month",
      traffic_renew_note: "Renewing a subscription does not reset used traffic",
      connection_online: "VPN online",
      connection_last_seen: "Last online: {{time}}",
      connection_unknown: "Connection status: no data",
      traffic_chart_title: "Traffic usage",
      traffic_chart_empty: "No traffic data yet",
      traffic_chart_total: "Total for period",
      traffic_chart_top_nodes: "Top locations",
      traffic_range_day: "Day",
      traffic_range_week: "Week",
      traffic_range_month: "Month",
      trial: {
        banner: "🎁 Get 15 days of free trial period!",
        activate: "Activate trial period"
      },
      connect : "Connect",
      payments: "Payment history",
      no_payments: "No payments yet",
      login: {
        title: "Sign in to account",
        description: "Authorization is required to access profile and manage subscription",
        google: "Sign in with Google"
      },
      logout: "Logout",
      select_plan: "Select a pricing plan",
      email: "Email",
      trial_used: "Trial period used",
      show_more: "Show more",
      show_less: "Show less",
      payment_status: {
        succeeded: "✅ Paid",
        pending: "⏳ Pending",
        canceled: "❌ Canceled"
      },
      subscription_link : "URL: {{link}}",
      referral: {
        title: "Referral program",
        description: "Invite your friends and get a 7-day subscription for each friend who activates the trial period!",
        total_referrals: "Total invited",
        active_referrals: "The trial period has been activated",
        copy: "Copy",
        copied: "Copied!"
      },
      show_qr: "Show QR"
    },
    paymentModal: {
      title: "Choose a payment method",
      method: {
        yookassa: "YooKassa (card/FPS)",
        platega: "Platega (card/FPS)",
        tribute: "Tribute (bot)",
        crypto: "Crypto (Heleket)",
      },
      action: {
        pay: "Pay",
        loading: "Loading...",
        cancel: "Cancel",
      },
      hints: {
        yookassa: "YooKassa — for Russian cards and FPS.",
        platega: "Platega - pay by card or FPS.",
        tribute: "Tribute — pay with cards worldwide via Telegram bot.",
        crypto: "Crypto — pay via Heleket.",
      },
      error: {
        generic: "Something went wrong..."
      },
      noMethods: "No payment methods available"
    },

    manual: {
      title: "Manual",
      subtitle: "VPN setup on devices",
      sidebar: {
        title: 'Instructions',
        subtitle: 'VPN setup on devices'
      },
      contentTitle: '{{app}} for {{device}}',
      selectDevice: 'Select device',
      stepByStep: 'Step-by-step VPN setup instructions',
      selectPrompt: 'Select your device and app from the menu to view detailed VPN setup instructions.'
    },
    footer: {
      copyright: "© 2026 Diamond VPN. All rights reserved.",
      support: "Support:",
      owner: "Service Owner: Diamond Services."
    },
    common: {
      loading: "Loading...",
      back: "Back"
    },
    supportChat: {
      open: "Open support chat",
      close: "Close",
      title: "Support Chat",
      placeholder: "Type a message...",
      send: "Send",
      sending: "Sending...",
      empty: "No messages yet. Write to us — we’ll reply.",
      too_long: "Message is too long (maximum 4000 characters).",
      fab: "Chat"
    },
    news: {
      title: "News",
      subtitle: "Fresh updates and service news.",
      empty: "No news yet.",
      end: "You have reached the end."
    },
    download: {
      title: "Download Apps",
      subtitle: "Choose your platform and install the app.",
      android: { title: "Android", desc: "Coming soon on Google play, but for now, so", button: "Download" },
      ios: { 
        title: "iOS", 
        desc: "Download Happ from App Store to use VPN.", 
        note: "Use Happ app to connect to VPN. Instructions are in the video below.",
        buttonRu: "Ru",
        buttonGlobal: "Global"
      },
      windows: { title: "Windows", desc: "", button: "Download" },
      howTo: {
        title: "How to use?",
        platformLabel: "Choose your platform:",
        windows: "Windows",
        android: "Android",
        ios: "iOS",
        otherInstructions: "Instructions for other applications"
      }
    },
    terms: {
      title: "User Agreement (Public Offer)",
      lastUpdated: "Last Updated: October 21, 2026",
      sections: {
        general: "1. General Provisions",
        subject: "2. Subject of the Agreement",
        ownerRights: "3. Rights and Obligations of the Owner",
        userRights: "4. Rights and Obligations of the User",
        responsibility: "5. Liability of the Parties and Dispute Resolution",
        ethics: "6. Ethical Principles of Use",
        final: "7. Final Provisions"
      },
      content: {
        general: {
          items: [
            "This User Agreement (hereinafter referred to as the Agreement) is a public offer in accordance with Article 437 of the Civil Code of the Russian Federation.",
            "Use of the Service by the User (including viewing materials posted on the Site, registration, subscription purchase) means full and unconditional acceptance by the User of the terms of this Agreement and the Privacy Policy.",
            "The owner of the Diamond VPN Service (hereinafter referred to as the Owner) is Diamond Services.",
            "The terms of this Agreement may be changed by the Owner unilaterally without prior notice."
          ]
        },
        subject: {
          items: [
            "The Owner grants the User a non-exclusive right to use the VPN connection Service (hereinafter referred to as the Service) in accordance with the terms of this Agreement.",
            "The Service is intended solely for ensuring security, confidentiality and protection of the User's data when using the Internet."
          ]
        },
        ownerRights: {
          items: [
            "The Owner undertakes to ensure technical access to the Service for the paid period.",
            "The Owner undertakes not to store or transfer to third parties the User's activity logs (No-Logs Policy) in accordance with the Privacy Policy.",
            "The Owner has the right to suspend or terminate the provision of the Service in case of violation of this Agreement by the User.",
            "The Owner has the right to make changes to tariff plans, software and technical characteristics of the Service with or without prior notice.",
            "The Owner is obliged to ensure compliance with the requirements of the Federal Law of July 27, 2006 N 152-FZ \"On Personal Data\" regarding the processing of personal data provided by the User (email for communication, payment data), as specified in the Privacy Policy."
          ]
        },
        userRights: {
          items: [
            "The User undertakes to use the Service only for lawful purposes and in accordance with the legislation of the Russian Federation and the country of their stay.",
            "The User bears full personal responsibility for any activity carried out by them while using the Service, including the content of transmitted information.",
            "The User is prohibited from using the Service for:",
            "The User undertakes not to transfer their credentials to third parties and is responsible for their security."
          ],
          prohibitedItems: [
              "Committing any illegal actions, including but not limited to: fraud, distribution of malware, unauthorized access to computer systems.",
              "Distribution of content prohibited or restricted by the legislation of the Russian Federation (child pornography, extremist materials, drug propaganda, etc.).",
              "Violation of copyright and related rights of third parties.",
              "Violation of the proper functioning of the Site and Service."
            ],
        },
        responsibility: {
          items: [
            "The Owner is not liable for any direct or indirect losses of the User arising from the use or inability to use the Service, except as provided by law.",
            "The Owner is not responsible for any illegal content or actions performed by the User while using the Service. The User is solely responsible for compliance with the law.",
            "All disputes and disagreements arising between the Parties in connection with the execution of this Agreement shall be resolved through negotiations.",
            "If no agreement is reached, disputes shall be resolved in court in accordance with the legislation of the Russian Federation at the location of the Service Owner."
          ]
        },
        ethics: {
          items: [
            "In order to form a responsible Internet community, the Service Owner adheres to the principles of honesty, respect and integrity. Users are recommended to use the Service only for permitted (legal and moral) purposes, avoiding actions contrary to moral and ethical standards."
          ]
        },
        final: {
          items: [
            "This Agreement enters into force from the moment the User expresses consent to its terms (acceptance) and is valid until termination.",
            "Acceptance of the Agreement is allowed only in full.",
            "Issues not regulated by this Agreement shall be resolved in accordance with the legislation of the Russian Federation."
          ]
        }
      }
    },
    refund: {
      title: "Diamond VPN Refund Policy",
      sections: {
        guarantee: "1. Refund Guarantee Terms",
        procedure: "2. Refund Request Procedure",
        timing: "3. Refund Processing Time",
        contacts: "4. Contacts"
      },
      content: {
        intro: "We strive for complete satisfaction of our users' needs. If you are not satisfied with the service, you can request a refund according to the following conditions.",
        guarantee: {
          description: "Diamond VPN Service provides a <b>14-day money-back guarantee</b> from the date of purchase of any paid tariff plan. Refund is possible subject to the following conditions:",
          items: [
            "The refund request must be submitted no later than <b>14 calendar days</b> after the payment is made.",
            "Refund cannot be made if the account was blocked due to violation of the \"Terms of Use\" (for example, illegal activity).",
            "If you have used the service to exceed the traffic volume of <b>50 GB</b>, we reserve the right to refuse a full refund (except in cases where the problem is on our side)."
          ]
        },
        procedure: {
          items: [
            "To request a refund, send an email to our email address <b>adverthueta@gmail.com</b>.",
            "In the email, specify:",
            "We will review your request within <b>3 business days</b>."
          ],
          procedureSubItems: [
              "Date and time of purchase.",
              "Transaction ID or payment number.",
              "The reason why you are requesting a refund."
            ],
        },
        timing: {
          description: "In case of refund approval:",
          items: [
            "The refund will be made to the same payment method that was used for the purchase.",
            "The crediting period may take <b>from 5 to 10 business days</b> and depends on your bank or payment system."
          ]
        },
        contacts: {
          description: "For all questions related to payment and refund, contact:",
          email: "Email: <b>adverthueta@gmail.com</b>"
        }
      }
    },
    privacy: {
      title: "Diamond VPN Privacy Policy",
      effectiveDate: "Effective Date: October 21, 2026",
      sections: {
        noLogs: "1. No-Logs Policy",
        technicalInfo: "2. Technical Information Collection",
        paymentInfo: "3. Payment Information",
        dataProtection: "4. Data Protection",
        thirdParty: "5. Third-Party Links"
      },
      content: {
        noLogs: {
          description: "Diamond VPN strictly adheres to a no-logs policy. This means that we <b>do not collect or store</b> the following information related to your online activity:",
          items: [
            "IP addresses used by you to connect to the Service.",
            "Browsing history or search queries.",
            "Session duration, connection time.",
            "Traffic used, files you download."
          ],
          conclusion: "Your online activity remains completely private and is not tracked by the Service."
        },
        technicalInfo: {
          description: "To ensure operation and provide services, we collect a minimal amount of technical information:",
          items: [
            "<b>Email address:</b> Used exclusively for communication, sending payment notifications and account recovery.",
            "<b>Connection technical data:</b> Traffic consumption data (for subscription control), device type (for optimization), and general server information, but without reference to specific user activity. This data is stored anonymously."
          ]
        },
        paymentInfo: {
          description: "For payment processing, we use third-party payment systems (via Telegram bot).",
          conclusion: "We <b>do not receive or store</b> information about your bank cards, accounts or other financial data. All financial information is processed directly by payment systems, which are responsible for its security."
        },
        dataProtection: "We take all reasonable measures to protect the information we collect. Your account is protected by a password. We use encryption for transmitting data related to account management.",
        thirdParty: "Our site may contain links to third-party resources (for example, to Telegram bot). We are not responsible for the privacy policy or content of these third-party sites."
      }
    }
  }
 };
 
class I18n {
  constructor() {
    this.language = this.getSavedLanguage() || this.detectLanguage();
    this.listeners = [];
  }

  detectLanguage() {

    // Автоопределение языка браузера
    const browserLang = navigator.language || navigator.userLanguage;
    
    // Если язык браузера русский или начинается с ru- (ru-RU, ru-UA и т.д.)
    if (browserLang.startsWith('ru')) {
      return 'ru';
    }
    
    // Для всех остальных случаев используем английский
    return 'en';
  }

  getSavedLanguage() {
    return localStorage.getItem('diamondvpn-language');
  }

  saveLanguage(lng) {
    localStorage.setItem('diamondvpn-language', lng);
  }

  t(key, params = {}) {
    const keys = key.split('.');
    let value = translations[this.language];
    
    for (const k of keys) {
      value = value?.[k];
    }
 
    if (typeof value === 'string' && params) {
      return value.replace(/\{\{(\w+)\}\}/g, (match, param) => params[param] || match);
    }
 
    return value || key;
  }

  changeLanguage(lng) {
    if (translations[lng]) {
      this.language = lng;
      this.saveLanguage(lng);
      this.notifyListeners();
    }
  }

  getLanguage() {
    return this.language;
  }

  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  notifyListeners() {
    this.listeners.forEach(listener => listener());
  }
}


export const i18n = new I18n();
